export const APPOINTMENT_TYPE_LABELS = {
  appuntamento: "Appuntamento",
  check: "Check-in",
  valutazione: "Valutazione",
  prova: "Prova gratuita",
};

export const APPOINTMENT_TYPE_COLORS = {
  appuntamento: "#007AFF",
  check: "#D4FF00",
  valutazione: "#34C759",
  prova: "#FF9500",
};
